import React from 'react';
import { motion } from 'framer-motion';

const GlassPanel = ({ 
  children, 
  className = '', 
  hover = true,
  ...props 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      whileHover={hover ? { y: -4 } : {}}
      className={`glass-panel rounded-xl p-4 sm:p-6 lg:p-8 transition-all duration-300 ${
        hover ? 'hover:border-primary/50' : ''
      } ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default GlassPanel;
